import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { GoToListPageButton } from '../../../../components/common/buttons/GoToListPageButton';
import { IInformation } from '../../../../interfaces/Information.interfaces';
import { InfoHorizontalListDetailView } from './InfoHorizontalListDetailView';

interface InfoHorizontalListDetailViewGroupProps {
  informations: IInformation[];
  pageType: 'home' | 'idp';
}

export const InfoHorizontalListDetailViewGroup = ({
  informations,
  pageType,
}: InfoHorizontalListDetailViewGroupProps) => {
  return (
    <Container id={'home-product-swiper-container'}>
      <CustomSwiper
        // 페이지 가로 너비에 따라서 한 Page에서 보여줄 Slide 수 계산
        slidesPerView={
          document.documentElement.clientWidth > 512 ? 512 / 332 : document.documentElement.clientWidth / 332
        }
        // 슬라이드 사이의 간격
        spaceBetween={16}
        // 전체보기 컴포넌트 사용을 위한 Swiper 우측 공간 크기 확보
        slidesOffsetAfter={166}
      >
        {informations.map((information, index) => (
          <CustomSwiperSlide key={information.id}>
            <InfoHorizontalListDetailView key={information.id} information={information} />
            {index === informations.length - 1 && <GoToListPageButton renderedIn={pageType} itemType={'info'} />}
          </CustomSwiperSlide>
        ))}
      </CustomSwiper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

const CustomSwiper = styled(Swiper)`
  width: calc(100% + 32px);
  min-height: 386px;

  padding: 0px 16px;

  transform: translateX(-16px);

  gap: 16px;
`;

const CustomSwiperSlide = styled(SwiperSlide)`
  height: 386px;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;

  cursor: pointer;
`;
